/* eslint-disable */
export default {
  namespaced: true,
  state: {
    userVideoRequest: {
      enableVideo: false,
      enableAudio: false,
      blurVideo: true,
      enableTranscription: false,
    },
    tableSettings: null,
  },
  getters: {
    userVideoRequestPersisted: (state) => state.userVideoRequest,
    getTableSettings: (state) => (tableName) => {
      if (state.tableSettings && state.tableSettings[tableName]) {
        return state.tableSettings[tableName];
      }
      return null;
    },
  },
  mutations: {
    setUserVideoRequestPersisted(state, value) {
      state.userVideoRequest = value;
    },
    clearTableSettings(state) {
      state.tableSettings = null;
    },
    updateTableSettings(state, data) {
      const { tableName, settings } = data;
      state.tableSettings = {
        ...state.tableSettings,
        [tableName]: { ...settings }
      };
    }
  },
};
